import styled from 'styled-components';
import { customMediaQuery } from 'students/views/shared/styled';

const SItemContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex-grow: 1;

  ${customMediaQuery('tablet')} {
    justify-content: space-evenly;
  }
`;

export default SItemContainer;
